import { getAllEsin204ContaResultado } from '@app/api/crf/CrfEsin204ContaResultado';
import { getAllRegistroCrfEsin204ByEsin204Id } from '@app/api/crf/CrtRegistroEsin204';
import { crfEsin204ViewModelResult, listCrfRegistroEsin204Importacao } from '@app/state/atom';
import { CompositeView, CrudContext, CrudMasterDetailView, GridView } from '@digital/ui';
import React, { useState, useMemo } from 'react';
import { useRecoilState } from 'recoil';
import CrfEsin204Importacao from './importacao';


const mensagemErroExportaLinhaDeReclassificacao = "É necessário ter ao menos um registro Reclass marcado como Verdadeiro para exportar a planilha";
const CrfEsin204ContaResultado = () => {


    const [esin204From, setEsin204From] = useRecoilState(crfEsin204ViewModelResult);
    const [allCrfEsin204ViewModel, setAllCrfEsin204ViewModel] = useState(() => getAllEsin204ContaResultado)


    const atualizarEsin204 = () => {
        setAllCrfEsin204ViewModel(() => Promise.resolve(undefined));
        setAllCrfEsin204ViewModel(() => getAllEsin204ContaResultado);
    }

    return (
        <CrudMasterDetailView
            getAllItems={allCrfEsin204ViewModel}
            filterPredicate={(item, value) =>
                item.ano.toString().startsWith(value)
            }
            titleExtractor={item =>
                item.ano.toString() + '/' + item.mes.toString()
            }
            detailTitleExtractor={
                item =>
                    item.ano.toString()
                    + ' - '
                    + item.mes.toString()
                    + ' - ' + item.processadoDescricao.toString() || '---'
            }
            descriptionExtractor={item => item.processadoDescricao.toString() || '---'} >
            <CrudContext.Consumer>
                {({ selectedItem }) => (
                    <CompositeView>
                        <>
                            {
                                setEsin204From(selectedItem)
                            }
                            <GridView
                                icon="industry-gears"
                                id="geral"
                                noform
                                title="EXECUTADO">
                                {selectedItem && esin204From ? (
                                    <>
                                        <CrfEsin204Importacao />
                                    </>) : (<> </>)}

                            </GridView>
                        </>
                    </CompositeView>
                )}
            </CrudContext.Consumer>
        </CrudMasterDetailView >
    );
};

export default CrfEsin204ContaResultado;
